import clsx from "clsx";

type PercentageProps = {
  percentage?: number;
  className?: string;
};

const Progress = ({ percentage, className }: PercentageProps) => {
  return (
    <div
      aria-label={String(percentage)}
      className="h-2 w-full rounded-full bg-foreground-lighter/20"
      role="progressbar"
    >
      <div
        className={clsx("h-2 rounded-full bg-primary", className)}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default Progress;
